import React from 'react';
import PropTypes from 'prop-types';
import { OnVisible } from '@americanexpress/data-manager-utils';
import clsx from 'clsx';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { Heading } from '@americanexpress/dls-react';
import SlideButton from './SlideButton';
import { CARD_OFFER_SHAPE } from '../../constants/cardOfferShapeConstants';
import styles from './Slide.scss';

const Slide = ({
  index,
  offer: {
    heading,
    subHeading,
    imageUrl,
    ctaLabel,
    redirectUrl,
    analyticElement: analyticDetail,
    analyticDetail: customAnalyticDetail,
  },
}) => {
  const id = `carouselSlide${index}`;
  const analyticElement = customAnalyticDetail || `hp-carousel-L${index}-banner`;

  return (
    <>
      <img className={styles.image} src={imageUrl} alt={heading} />
      <OnVisible
        analyticsInfo={{
          element: analyticElement,
          detail: analyticDetail,
        }}
      >
        <div
          id={id}
          className={clsx(
            'stack pad-2 radius-container-sm position-absolute-tl margin-responsive',
            styles.cardTile
          )}
        >
          <Heading
            level={4}
            variant="sans-large-book"
            className={clsx('color-text-brand-alt text-align-left', styles.heading)}
            dangerouslySetInnerHTML={{ __html: sanitize(heading) }}
          />
          {/* eslint-disable-next-line react/no-danger -- data from oneCMS */}
          <p className="margin-3-b text-align-left" dangerouslySetInnerHTML={{ __html: sanitize(subHeading) }} />
          <SlideButton
            id={`${id}Button`}
            analyticDetail={analyticDetail}
            analyticElement={analyticElement}
            ctaLink={redirectUrl}
            ctaText={ctaLabel}
          />
        </div>
      </OnVisible>
    </>
  );
};

Slide.propTypes = {
  index: PropTypes.number.isRequired,
  offer: PropTypes.shape(CARD_OFFER_SHAPE).isRequired,
};

export default Slide;
